import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const ZData = z.object({
  companyName: z.string().nullable(),
  site: z.optional(z.any())
})

export const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(z.array(ZData)),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export async function fetchSidebarMenuInfo (
  onSuccess: (device: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().SiteManagementCollectionStrings.TableComponent
  const url = '/assetrest/api/v2/udp/tiq/assets/enterpriseHierarchy'
  interceptedAxios.get(url, { timeout: 20000 })
    .then((response) => {
      const parseResponse = response.data
      if (parseResponse.error === false) {
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
